import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import LoginForm from "@/components/auth/LoginForm.vue";
import AlertBanner from "@/components/feedback/AlertBanner.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const showRegisterMessage = computed(() => route.query.registered === "true");

const onLoginSuccess = () => {
  const redirectTarget =
    typeof route.query.redirect === "string" ? route.query.redirect : "/";
  router.push(redirectTarget).catch(() => null);
};

const goToRegister = () => {
  router.push("/register").catch(() => null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showRegisterMessage.value)
      ? (_openBlock(), _createBlock(AlertBanner, {
          key: 0,
          type: "info",
          message: _ctx.$t('We have sent a confirmation email. Check your inbox to activate your account.')
        }, null, 8, ["message"]))
      : _createCommentVNode("", true),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(LoginForm, {
        onLoginSuccess: onLoginSuccess,
        onGoToRegister: goToRegister
      })
    ])
  ], 64))
}
}

})